import React, { useContext } from 'react';
import CheckBox from '../ui/CheckBox';
import SecondaryButton from '../ui/SecondaryButton';
import ApplicationContext from '../ApplicationContext';

export interface FooterButton {
    name?: string;
    text: string;
    onClick?: () => void;
    disabled?: boolean;
    width?: string;
    id?: string;
}

interface DocReportCardProps {
    title: string;
    width?: number | string;
    height?: number | string;
    showFootprint?: boolean;
    onFootprintChange?: (value: boolean) => void;
    checkBoxDisabled?: boolean;
    children?: React.ReactNode;
    footerMargin?: string;
    footerButtonGap?: number | string;
    footerButtons?: FooterButton[];
    showTopTitle?: boolean;
    /** 타이틀 바 우측에 붙는 액션(Refresh 아이콘 등). 카드 오른쪽 끝에 맞춰 정렬된다. */
    titleRight?: React.ReactNode;
}

const DocReportCard: React.FC<DocReportCardProps> = ({
    title,
    width = 500,
    height,
    showFootprint,
    onFootprintChange,
    checkBoxDisabled = false,
    showTopTitle = true,
    children,
    footerMargin = '40px',
    footerButtonGap = '20px',
    footerButtons = [],
    titleRight,
}) => {
    const appContext = useContext(ApplicationContext);

    const showFooterBtn = footerButtons.length > 0;

    const bgClassMap: Record<string, string> = {
        W: 'white',
        A: 'aqua',
        I: 'ivory',
    };
    
    const footerClassName = footerButtons.length >= 3
        ? 'report-footer-3buttons'
        : 'report-footer-2buttons';

    const FooterButtons = () => (
        <>
            {footerButtons.map((btn, index) => (
                <SecondaryButton
                    key={btn.name ?? index}
                    focusable
                    name={btn.name}
                    size="regular"
                    style={{ width: btn.width ?? '90px' }}
                    onClick={btn.onClick}
                    disabled={btn.disabled}
                    id={btn.id ?? ''}
                >
                    {btn.text}
                </SecondaryButton>
            ))}
        </>
    );

    return (
        <div className={`doc-details-v2 background-${appContext.backgroundColor}`}>
            <div className="doc-details-container-v2-report">
                {showTopTitle &&
                    <div className="oi-doc-title-row2-report">
                        <div className="oi-doc-title2" style={{ width: '500px', marginLeft: '70px' }}>
                            <div className={!appContext.useDarkMode ? 'oi-doc-title-label2' : 'oi-doc-title-label2-darkmode'}>
                                {title}
                            </div>
                        </div>
                        {/* 카드(.doc-left-v2)의 오른쪽 끝에 맞춰 우측 정렬. width 는 카드 바깥 폭(전역 border-box), 24 는 카드 margin-left. */}
                        {titleRight && (
                            <div style={{
                                position: 'absolute', top: 0, bottom: 0, left: 24, width,
                                display: 'flex', alignItems: 'center', justifyContent: 'flex-end', pointerEvents: 'none',
                            }}>
                                <div style={{ pointerEvents: 'auto' }}>{titleRight}</div>
                            </div>
                        )}
                    </div>
                }
                <div style={{ width: '100%', overflowY: 'auto', paddingBottom: '6px' }}>
                    <div className={`doc-left-v2 ${bgClassMap[appContext.backgroundColor] ?? 'white'}`} style={{ width, ...(height !== undefined && { height }) }}>

                        {children}

                        <div style={{ marginTop: footerMargin }} />

                        {showFooterBtn && (
                            onFootprintChange ? (
                                <div
                                    className={footerClassName}
                                    style={{ position: 'relative', display: 'flex' }}
                                >
                                    <div style={{ position: 'absolute', left: '10px', top: '10px' }}>
                                        <CheckBox
                                            value={showFootprint ?? false}
                                            onChange={onFootprintChange}
                                            label="Show Footprint"
                                            disabled={checkBoxDisabled}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', gap: footerButtonGap }}>
                                        <FooterButtons />
                                    </div>
                                </div>
                            ) : (
                                <div className={footerClassName}>
                                    <FooterButtons />
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocReportCard;